/* eslint-disable global-require */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from '../reducers';

export default (apolloClient, preloadedState = {}) => {
  const isFunction = f => typeof f === 'function';
  const enhancers = [].filter(isFunction);
  const apolloMiddleware = apolloClient && apolloClient.middleware && apolloClient.middleware();
  const middleware = [thunk, apolloMiddleware].filter(isFunction);

  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const composedEnhancers = composeEnhancers(applyMiddleware(...middleware), ...enhancers);

  const store = createStore(rootReducer, preloadedState, composedEnhancers);

  // hot module reload - Awwww yeah 🎉 !!!
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default;

      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
};



// WEBPACK FOOTER //
// ./src/store/dev.js